import { SET_VP } from './types';

const initialState = null;

export const vpReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VP:
      return action.payload ? { ...state, ...action.payload } : state;
    default:
      return state;
  }
};
